(() => {
  if (window.productCollapsibleDesktopOpenReady) return;
  window.productCollapsibleDesktopOpenReady = true;

  const selector = 'collapsible-row.product__accordion--always-open-desktop';
  const desktop = window.matchMedia('(min-width: 769px)');
  const states = new WeakMap();

  function syncTimeline(row, open) {
    if (!row.tl) return;

    // 与主题原有的折叠动画状态保持一致，避免回到移动端后需要点击两次。
    row.tl.pause();
    row.tl.progress(open ? 1 : 0, true);
    row.tl.reversed(!open);
    row.details.style.removeProperty('height');
    row.details.style.removeProperty('overflow');
  }

  function sync(row) {
    const state = states.get(row);
    if (!state || state.desktop === desktop.matches) return;

    if (state.desktop === false) state.mobileOpen = state.details.open;
    state.desktop = desktop.matches;
    state.details.open = state.desktop ? true : state.mobileOpen;

    if (state.desktop) {
      state.summary.setAttribute('tabindex', '-1');
      state.summary.setAttribute('aria-disabled', 'true');
    } else {
      if (state.originalTabIndex === null) {
        state.summary.removeAttribute('tabindex');
      } else {
        state.summary.setAttribute('tabindex', state.originalTabIndex);
      }
      state.summary.removeAttribute('aria-disabled');
    }

    syncTimeline(row, state.details.open);
  }

  function initialize(root) {
    const rows = root.matches?.(selector) ? [root] : root.querySelectorAll(selector);

    rows.forEach(row => {
      if (states.has(row)) return;
      const details = row.querySelector('details');
      const summary = details?.querySelector('summary');
      if (!details || !summary) return;

      const state = {
        details,
        summary,
        mobileOpen: row.dataset.mobileOpen === 'true',
        originalTabIndex: summary.getAttribute('tabindex'),
        desktop: null
      };
      states.set(row, state);

      summary.addEventListener('click', event => {
        if (!desktop.matches) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        details.open = true;
      }, true);

      details.addEventListener('toggle', () => {
        if (desktop.matches) {
          if (!details.open) {
            details.open = true;
            syncTimeline(row, true);
          }
        } else {
          state.mobileOpen = details.open;
        }
      });

      sync(row);
    });
  }

  desktop.addEventListener('change', () => {
    document.querySelectorAll(selector).forEach(sync);
  });
  document.addEventListener('shopify:section:load', event => initialize(event.target));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  } else {
    initialize(document);
  }
})();
